import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';

@Component({
  selector: 'app-changeplan-terms',
  templateUrl: './changeplan-terms.component.html',
  styleUrls: ['./changeplan-terms.component.sass']
})
export class ChangeplanTermsComponent implements OnInit {

  constructor(private loadingScreenService :LoadingScreenService,public matDialogRef:MatDialogRef<ChangeplanTermsComponent>,private services: Service,private global:GlobalService,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) { }

  ngOnInit() {}
  public close(){
    if(this.global.validateSession()===true){
      this.matDialogRef.close('cancel');
    }
  }
}
